import type { IPartyEvent } from './IPartyEvent';

/** Підпис події: назва запису, без неї — номер (прототип v4: title || code). Чиста функція. */
export function eventLabel(event: IPartyEvent): string {
  return event.record.title || String(event.record.code);
}

/** Підказка події: «Тип · статус» (статус — підписом типу, невідомий — значенням). Чиста функція. */
export function eventTip(event: IPartyEvent): string {
  const status = event.record.status ? event.type.statuses[event.record.status] ?? event.record.status : '';
  return [event.type.label, status].filter(Boolean).join(' · ');
}
